module.exports = __webpack_public_path__ + "media/images/lig/life-is-good-callout-49f577d5c5e73e14aa68a20c192d7724.jpg";